<template>
  <div class="flex flex-col gap-4 lg:gap-1">
    <p class="text-regular-semibold hyphens-auto">{{ t('components.ai-search.title') }}</p>

    <div class="flex gap-0 w-full">
      <label class="sr-only" :for="`ai-search-${itemId}`">{{ t('components.ai-search.label') }}</label>
      <input
        ref="inputRef"
        type="text"
        :id="`ai-search-${itemId}`"
        v-model="searchQuery"
        @keyup.enter="handleSearch"
        @focus="handleFocus"
        @blur="handleBlur"
        :placeholder="placeholder"
        class="flex-1 rounded-r-none border-r-0"
        style="text-align: left; direction: ltr"
      />
      <SharedIconButton
        class="!block lg:!hidden !rounded-l-none !h-[50px]"
        @click="handleSearch"
        variant="orange"
        :aria-label="t('components.ai-search.button')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M10.8359 13.7108L9.33585 17.7811C9.29146 17.9007 9.21152 18.0039 9.10677 18.0768C9.00203 18.1496 8.8775 18.1886 8.74992 18.1886C8.62233 18.1886 8.4978 18.1496 8.39306 18.0768C8.28832 18.0039 8.20838 17.9007 8.16398 17.7811L6.66398 13.7108C6.63232 13.6249 6.5824 13.5469 6.51766 13.4821C6.45291 13.4174 6.37489 13.3675 6.28898 13.3358L2.21867 11.8358C2.09906 11.7914 1.9959 11.7115 1.92305 11.6067C1.8502 11.502 1.81116 11.3775 1.81116 11.2499C1.81116 11.1223 1.8502 10.9978 1.92305 10.893C1.9959 10.7883 2.09906 10.7083 2.21867 10.6639L6.28898 9.16395C6.37489 9.13229 6.45291 9.08237 6.51766 9.01763C6.5824 8.95288 6.63232 8.87486 6.66398 8.78895L8.16398 4.71864C8.20838 4.59903 8.28832 4.49587 8.39306 4.42302C8.4978 4.35017 8.62233 4.31113 8.74992 4.31113C8.8775 4.31113 9.00203 4.35017 9.10677 4.42302C9.21152 4.49587 9.29146 4.59903 9.33585 4.71864L10.8359 8.78895C10.8675 8.87486 10.9174 8.95288 10.9822 9.01763C11.0469 9.08237 11.1249 9.13229 11.2109 9.16395L15.2812 10.6639C15.4008 10.7083 15.5039 10.7883 15.5768 10.893C15.6496 10.9978 15.6887 11.1223 15.6887 11.2499C15.6887 11.3775 15.6496 11.502 15.5768 11.6067C15.5039 11.7115 15.4008 11.7914 15.2812 11.8358L11.2109 13.3358C11.1249 13.3675 11.0469 13.4174 10.9822 13.4821C10.9174 13.5469 10.8675 13.6249 10.8359 13.7108Z"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="M13.75 1.25V5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M15.625 3.125H11.875"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.5 5.625V8.125"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.75 6.875H16.25"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </SharedIconButton>
      <SharedButton
        @click="handleSearch"
        variant="orange"
        :label="t('components.ai-search.button')"
        class="!rounded-t-none  md:rounded-l-none md:!rounded-bl-none md:!rounded-r-sm !hidden lg:!flex items-center"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M10.8359 13.7108L9.33585 17.7811C9.29146 17.9007 9.21152 18.0039 9.10677 18.0768C9.00203 18.1496 8.8775 18.1886 8.74992 18.1886C8.62233 18.1886 8.4978 18.1496 8.39306 18.0768C8.28832 18.0039 8.20838 17.9007 8.16398 17.7811L6.66398 13.7108C6.63232 13.6249 6.5824 13.5469 6.51766 13.4821C6.45291 13.4174 6.37489 13.3675 6.28898 13.3358L2.21867 11.8358C2.09906 11.7914 1.9959 11.7115 1.92305 11.6067C1.8502 11.502 1.81116 11.3775 1.81116 11.2499C1.81116 11.1223 1.8502 10.9978 1.92305 10.893C1.9959 10.7883 2.09906 10.7083 2.21867 10.6639L6.28898 9.16395C6.37489 9.13229 6.45291 9.08237 6.51766 9.01763C6.5824 8.95288 6.63232 8.87486 6.66398 8.78895L8.16398 4.71864C8.20838 4.59903 8.28832 4.49587 8.39306 4.42302C8.4978 4.35017 8.62233 4.31113 8.74992 4.31113C8.8775 4.31113 9.00203 4.35017 9.10677 4.42302C9.21152 4.49587 9.29146 4.59903 9.33585 4.71864L10.8359 8.78895C10.8675 8.87486 10.9174 8.95288 10.9822 9.01763C11.0469 9.08237 11.1249 9.13229 11.2109 9.16395L15.2812 10.6639C15.4008 10.7083 15.5039 10.7883 15.5768 10.893C15.6496 10.9978 15.6887 11.1223 15.6887 11.2499C15.6887 11.3775 15.6496 11.502 15.5768 11.6067C15.5039 11.7115 15.4008 11.7914 15.2812 11.8358L11.2109 13.3358C11.1249 13.3675 11.0469 13.4174 10.9822 13.4821C10.9174 13.5469 10.8675 13.6249 10.8359 13.7108Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M13.75 1.25V5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M15.625 3.125H11.875"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.5 5.625V8.125"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.75 6.875H16.25"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </template>
      </SharedButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n();

  const itemId = useId();

  const searchQuery = ref('');
  const placeholder = ref(t('components.ai-search.placeholder'));
  const displayText = ref('');
  const currentSentenceIndex = ref(0);
  const isTyping = ref(false);
  const isDeleting = ref(false);
  const isFocused = ref(false);
  const animationTimeout = ref<NodeJS.Timeout | null>(null);
  const inputRef = useTemplateRef<HTMLInputElement | null>('inputRef');
  const { width: inputWidth } = useElementSize(inputRef);

  const props = withDefaults(
    defineProps<{
      autoType?: boolean;
    }>(),
    {
      autoType: true,
    }
  );

  const sentences = [
    t('components.ai-search.autoType.1'),
    t('components.ai-search.autoType.2'),
    t('components.ai-search.autoType.3'),
    t('components.ai-search.autoType.4'),
    t('components.ai-search.autoType.5'),
  ];

  // Calculate max visible characters based on reactive input width
  const maxVisibleChars = computed(() => {
    if (!inputWidth.value) return 30; // fallback

    const padding = 16; // approximate padding (8px left + 8px right)
    const availableWidth = inputWidth.value - padding;

    // Approximate character width (varies by font, but 8px is a good average)
    const avgCharWidth = 8;
    const maxChars = Math.floor(availableWidth / avgCharWidth);

    return Math.max(10, maxChars); // minimum 10 characters
  });

  const typeText = async () => {
    if (!props.autoType || isFocused.value) return;

    const currentSentence = sentences[currentSentenceIndex.value];
    if (!currentSentence) return;

    if (!isDeleting.value) {
      // Typing phase
      if (displayText.value.length < currentSentence.length) {
        displayText.value = currentSentence.substring(0, displayText.value.length + 1);
        // Show the end of the text when it gets long (like scrolling)
        if (displayText.value.length > maxVisibleChars.value) {
          const startIndex = displayText.value.length - maxVisibleChars.value;
          placeholder.value = '...' + displayText.value.substring(startIndex) + '|';
        } else {
          placeholder.value = displayText.value + '|';
        }
        animationTimeout.value = setTimeout(typeText, 45); // Typing speed
      } else {
        // Finished typing, wait then start deleting
        animationTimeout.value = setTimeout(() => {
          isDeleting.value = true;
          typeText();
        }, 1500); // Wait 2 seconds before deleting
      }
    } else {
      // Deleting phase
      if (displayText.value.length > 0) {
        displayText.value = displayText.value.substring(0, displayText.value.length - 1);
        // Show the end of the text when it gets long (like scrolling)
        if (displayText.value.length > maxVisibleChars.value) {
          const startIndex = displayText.value.length - maxVisibleChars.value;
          placeholder.value = '...' + displayText.value.substring(startIndex) + '|';
        } else {
          placeholder.value = displayText.value + '|';
        }
        animationTimeout.value = setTimeout(typeText, 12); // Deleting speed (much faster)
      } else {
        // Finished deleting, move to next sentence
        isDeleting.value = false;
        currentSentenceIndex.value = (currentSentenceIndex.value + 1) % sentences.length;
        animationTimeout.value = setTimeout(typeText, 500); // Wait before starting next sentence
      }
    }
  };

  const handleFocus = () => {
    isFocused.value = true;
    // Clear any pending animation
    if (animationTimeout.value) {
      clearTimeout(animationTimeout.value);
      animationTimeout.value = null;
    }
    // Remove placeholder text
    placeholder.value = '';
  };

  const handleBlur = () => {
    isFocused.value = false;
    // Restart animation if autoType is enabled
    if (props.autoType) {
      // Reset to default placeholder if no text is being displayed
      if (!displayText.value) {
        placeholder.value = t('components.ai-search.placeholder');
      }
      // Restart animation after a short delay
      setTimeout(typeText, 500);
    }
  };

  onMounted(() => {
    if (props.autoType) {
      // Start typing animation after a short delay
      setTimeout(typeText, 1000);
    }
  });

  const eventBus = useEventBus();

  const handleSearch = () => {
    eventBus.emit('open-aichat-modal', searchQuery.value);
    searchQuery.value = '';
  };
</script>

<style></style>
